import { render, staticRenderFns } from "./BenefitTextBox.vue?vue&type=template&id=f0bd98e2&scoped=true&"
import script from "./BenefitTextBox.vue?vue&type=script&lang=js&"
export * from "./BenefitTextBox.vue?vue&type=script&lang=js&"
import style0 from "./BenefitTextBox.vue?vue&type=style&index=0&id=f0bd98e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bd98e2",
  null
  
)

export default component.exports